/**
 * Master Sheet Formula: Thread Pitch
 *
 * Formula:
 * =_xlfn.XLOOKUP(_xlfn.CONCAT(H4," ",K4),'Thread Blank Diameter III.'!$AM$3:$AM$1001,'Thread Blank Diameter III.'!$AO$3:$AU$1001)
 *
 * Variables:
 * - H4: Fastener Type
 * - K4: Thread Size
 *
 * Notes:
 * - This formula is part of data validation and not an actual formula that we can parse.
 */

import { StandardResult } from '@calculations/utilities/result';
import type { StringListMapDataSchema } from '@snap-types/models/auto-configurator-data-set';
import { err, ok } from 'neverthrow';

type Inputs = {
  fastenerType: string;
  threadSize: string;
  threadPitchOptions: StringListMapDataSchema;
};

export function getThreadPitchOptions({
  fastenerType,
  threadSize,
  threadPitchOptions,
}: Inputs): StandardResult<string[]> {
  const key = `${fastenerType} ${threadSize}`;
  const options = threadPitchOptions[key];

  if (options === undefined) {
    return err({
      message: `Thread pitch not found for ${key}`,
      context: {
        fastenerType,
        threadSize,
        threadPitchOptions,
      },
    });
  }

  return ok(options);
}
